import React from "react";
import styled from "styled-components";
import { colors2, UI_BODY_SM, UI_BODY_SEMIBOLD_SM } from "oolib";
import { ButtonTertiaryCompact } from "oolib/dist/v2/components/Buttons";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { redOutline } from "./styled";

/**
 * "Connected to {account}" with the connecting email under it and a Disconnect
 * button, at the top of an integration's import popup.
 */

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid ${colors2.grey10};
  border-radius: 12px;
`;

export const ConnectionCard = ({
  account,
  email,
  disconnectDisabled,
  onDisconnect,
}) => (
  <Wrapper>
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <DisplayIcon icon="CheckCircle" size={18} color={colors2.green} />
        <UI_BODY_SEMIBOLD_SM style={{ color: colors2.greenText }}>
          {`Connected to ${account}`}
        </UI_BODY_SEMIBOLD_SM>
      </div>
      {email && <UI_BODY_SM style={{ paddingLeft: 24 }}>{email}</UI_BODY_SM>}
    </div>
    <ButtonTertiaryCompact
      icon="X"
      iconColor={colors2.red}
      style={redOutline}
      disabled={disconnectDisabled}
      onClick={onDisconnect}
    >
      Disconnect
    </ButtonTertiaryCompact>
  </Wrapper>
);

export default ConnectionCard;
